import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react';
import { useNavigate } from "react-router-dom";

import secureLocalStorage from "react-secure-storage";

import { IMAGES } from '../utils/images';

import UserService from '../services/user.service';

import './login.css';
import { useAuth } from '../AuthProvider';

const LoginPage: React.FC = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const { setLoggedInUser } = useAuth();

    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('authenticated');
        secureLocalStorage.removeItem('user');
    }, []);

    async function login(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (email === "" || password === "") return;

        const data = {
            email: email,
            password: password,
        };

        try {
            const response = await UserService.login(data);
            console.log(response.data);
            
            // UserService.login automatically stores the JWT token
            setLoggedInUser(response.data.user);
            navigate("/home");
        } catch (error: any) {
            if (error.response) {
                if (error.response.status === 401) {
                    alert("Invalid Login!");
                } else {
                    alert("Failed to log in");
                    console.log("Error: ", error);
                }
            } else {
                alert("Failed to log in");
                console.log("Error: ", error);
            }
        }
    }

    return (
        <div className="login_page" style={{ backgroundImage: `url(${IMAGES.backgrounds.room})` }}>
            <img src={IMAGES.logo} className="logo" alt="Logo" />
            <div className="login_container">
                <p className="login_text">Login</p>
                <form className="form_container" onSubmit={login}>
                    <input
                        type="email"
                        placeholder='Email...'
                        value={email}
                        className="form_option"
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder='Password...'
                        value={password}
                        className="form_option"
                        onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                    />
                    <button type="submit" className="button_std submit_button">
                        Submit
                    </button>
                </form>
                <p className='link' onClick={() => navigate('/createaccount')}>Don't have an account? Create one!</p>
                <p className='link' onClick={() => navigate("/home")}>Continue as Guest</p>
            </div>
        </div>
    );
};

export default LoginPage;

